<template>
  <baseEdit></baseEdit>
</template>
<script>
  import baseEdit from './baseEdit.vue';

  export default {
    components: {
      baseEdit,
    },
    name: 'saleInvoiceAddCK',
  };
</script>
